module.exports = function() {
  return new Worker(__webpack_public_path__ + "0b2ebc246b4cc8f76c9f.worker.js");
};